import { Text } from 'braid-design-system';
import Markdown from 'markdown-to-jsx';

type Props = {
  content: string;
  textSize?: 'small' | 'standard' | 'large';
};

export const MarkdownContent: React.FC<Props> = ({
  content,
  textSize = 'small',
}) => (
  <Markdown
    options={{
      disableAutoLink: true,
      disableParsingRawHTML: true,
      wrapper: (props) => <Text {...props} size={textSize} />,
    }}
  >
    {content}
  </Markdown>
);
